import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './polyfills';

// 🔧 Setup MonacoEnvironment for worker loading
(self as any).MonacoEnvironment = {
  getWorkerUrl: function (_moduleId: string, label: string) {
    switch (label) {
      case 'json':
        return './assets/monaco/min/vs/language/json/json.worker.js';
      case 'css':
      case 'scss':
      case 'less':
        return './assets/monaco/min/vs/language/css/css.worker.js';
      case 'html':
      case 'handlebars':
      case 'razor':
        return './assets/monaco/min/vs/language/html/html.worker.js';
      case 'typescript':
      case 'javascript':
        return './assets/monaco/min/vs/language/typescript/ts.worker.js';
      default:
        return './assets/monaco/min/vs/editor/editor.worker.js';
    }
  }
};


if (environment.production) {
  enableProdMode();
}

if (environment.env === 'production' || environment.env === 'staging-hosted') {
  Sentry.init({
    environment: environment.env === 'production' ? 'Production' : (environment.env === 'staging-hosted' ? 'Staging' : environment.env),
    dsn: 'https://865c3777158f3b96a33fa81cf230728c@o4505827152822272.ingest.sentry.io/4505828007084032',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))
  .finally(() => {
    // Initialize Stagewise toolbar only in development mode
    if ((environment.env === 'localNoKube' || environment.env === 'localDev') && typeof window !== 'undefined') {
      // Use dynamic import with proper error handling
      import('@stagewise/toolbar').then((stagewiseModule: any) => {
        const { initToolbar } = stagewiseModule;
        if (typeof initToolbar === 'function') {
          const stagewiseConfig = {
            plugins: []
          };
          initToolbar(stagewiseConfig);
          console.log('[Stagewise] Toolbar initialized successfully');
        } else {
          console.warn('[Stagewise] initToolbar function not found in module');
        }
      }).catch(err => {
        console.warn('[Stagewise] Failed to initialize toolbar:', err);
      });
    }
  });
